import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CRVRequest from './Request/Request';
import CRVApprove from './Approve/Approve';

const ClinicalRecordingVidyo = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route
				path={`${path}/Approve`}
				exact
				render={props => (
					<CRVApprove querystring={props.location.search} />
				)}
			/>
			<Route
				path={`${path}/Request`}
				exact
				render={props => (
					<CRVRequest querystring={props.location.search} />
				)}
			/>
			<Route path='*'>404...</Route>
		</Switch>
	);
};
export default ClinicalRecordingVidyo;
